import React from 'react'

const Portal = () => {
  return (
    <div>Redirected Successfully</div>
  )
}

export default Portal